export default "__VITE_ASSET__D4YtRK8m__"